import { render, staticRenderFns } from "./AddHospitalisation.vue?vue&type=template&id=5ba871cf&scoped=true"
import script from "./AddHospitalisation.vue?vue&type=script&lang=js"
export * from "./AddHospitalisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba871cf",
  null
  
)

export default component.exports